import { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { success, error } from "../Global/toast";
import APICallService from "../api/apiCallService";
import { USER_DELETE } from "../api/apiEndPoints";
import LOGO from "../assets/media/Logo.svg";
import clsx from "clsx";
import axios from "axios";

const UserDelete = () => {
  const [email, setEmail] = useState("");
  const [userType, setUserType] = useState("customer");
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    if (!email.trim() || !emailRegex.test(email.trim())) {
      setValidationError(true);
      return;
    }

    setLoading(true);

    const apiService = new APICallService(USER_DELETE, {
      email,
      role: userType === "customer" ? 1 : 2,
    });

    try {
      const settings = await apiService.findSettings(
        apiService.apiName,
        apiService.apiType,
        apiService.params,
        apiService.path,
        apiService.type
      );
      const response = await axios(settings.url, settings);
      if (response && response.data) {
        success("Account deletion request submitted successfully.");
        setEmail("");
        setUserType("customer");
        setValidationError(false);
      }
    } catch (err: any) {
      let errMsg = "Failed to submit account deletion request.";
      if (err?.response?.data) {
        let data = err.response.data;
        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch (e) {
            // If it's a plain string, use it
          }
        }
        if (data && typeof data === "object" && data.error) {
          errMsg = data.error;
        } else if (typeof data === "string" && data.trim()) {
          errMsg = data;
        }
      } else if (err?.message) {
        errMsg = err.message;
      }
      error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wrapper overflow-hidden bg-cultured d-flex flex-column min-vh-100 pt-14">
      <div className="position-relative bg-cultured user-delete-sec z-0 w-100 flex-grow-1 d-flex align-items-center justify-content-center pb-10">
        <div className="container">
        <div className="card bg-primary br-30 w-100 mx-auto" style={{ maxWidth: "850px" }}>
          <div className="card-body p-md-7 p-lg-10">
            <div className="row align-items-center">
              <div className="col-md-5 mb-8 mb-md-0 text-center text-md-start pe-md-6">
                <img
                  src={LOGO}
                  alt="Hitch Logo"
                  width={120}
                  className="mb-6 img-fluid"
                />
                <h2 className="fs-32 fw-bolder text-white mb-3">Delete Account</h2>
                <p className="fs-16 fw-normal text-white-50 mb-0">
                  Deleting your account will remove all of your information from our database.
                </p>
              </div>

              <div className="col-md-7 border-md-start border-secondary ps-md-8" style={{ borderColor: "rgba(255,255,255,0.1) !important" }}>
                <Form onSubmit={handleSubmit} noValidate>
                  <Form.Group className="mb-6">
                    <Form.Label className="text-white fs-16 fw-600 mb-3">Account Type</Form.Label>
                    <div className="d-flex gap-6">
                      <Form.Check
                        type="radio"
                        id="type-customer"
                        label="Customer"
                        name="userType"
                        className="text-white"
                        checked={userType === "customer"}
                        onChange={() => setUserType("customer")}
                      />
                      <Form.Check
                        type="radio"
                        id="type-driver"
                        label="Driver"
                        name="userType"
                        className="text-white"
                        checked={userType === "driver"}
                        onChange={() => setUserType("driver")}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-8" controlId="deleteEmail">
                    <Form.Label className="text-white fs-16 fw-600 mb-2">Email</Form.Label>
                    <Form.Control
                      type="email"
                      className={clsx(
                        "form-control bg-transparent",
                        validationError ? "border-danger" : ""
                      )}
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setValidationError(false);
                      }}
                      disabled={loading}
                      autoComplete="off"
                    />
                    {validationError && (
                      <Form.Text className="mt-2 d-block" style={{ color: "#ffbaba" }}>
                        Please enter a valid email address.
                      </Form.Text>
                    )}
                  </Form.Group>

                  <div className="mt-7">
                    <Button
                      type="submit"
                      className="btn btn-white py-lg-7 w-100 fw-bold"
                      disabled={loading}
                    >
                      {loading ? (
                        <span>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Submitting...
                        </span>
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </div>
                </Form>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDelete;
